import { createSlice, isFulfilled, isPending, isRejected } from '@reduxjs/toolkit'
import { initialFeedbackWidgetState } from 'store/feedbackWidget/initial.ts'
import { getWidgets } from 'store/feedbackWidget/thunks'

export const feedbackWidgetSlice = createSlice({
  name: 'feedbackWidgets',
  initialState: initialFeedbackWidgetState,
  reducers: {},
  extraReducers: (builder) => {
    // SPECIFIC THUNK REDUCERS
    builder.addCase(getWidgets.fulfilled, (state, { payload }) => {
      state.widgets = payload.widgets
    })

    // IS PENDING MATCHER
    builder.addMatcher(isPending(getWidgets), (state) => {
      state.loading = true
      state.error = false
    })

    // IS FULFILLED
    builder.addMatcher(isFulfilled(getWidgets), (state) => {
      state.loading = false
      state.error = false
    })

    // IS REJECTED
    builder.addMatcher(isRejected(getWidgets), (state) => {
      state.loading = false
      state.error = true
    })
  }
})

export default feedbackWidgetSlice.reducer
